import React, { useState, useEffect } from "react";
import Select from "react-select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import toast, { Toaster } from "react-hot-toast";
import { Modal } from "react-bootstrap";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddIcon from "@mui/icons-material/Add";
import {
  addCountry,
  addStateRegion,
  getCountryKeyValuePair,
  getStateKeyValue,
  addNewAddress,
} from "../../services/index";

const Address = ({ child1, child2, custDetail, ...props }) => {
  useEffect(() => {
    getCountryList();
    getStateList();
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [countryKeyValue, setCountryKeyValue] = useState([]);
  const [stateKeyValue, setStateKeyValue] = useState([]);
  const [modalData, setModalData] = useState({
    countryCode: "",
    countryTitle: "",
    stateCode: "",
    stateTitle: "",
  });

  const [modalSwitches, setModalSwitches] = useState({
    countryModal: false,
    stateModal: false,
  });
  const [addInfo, setAddInfo] = useState({
    addressId: 0,
    addressType: "Shipping",
    attention: "string",
    city: "Jaipur",
    country: "string",
    fax: 0,
    isAdditionalAddress: true,
    // "recordId": "string",
    state: "string",
    addressLine1: "s1",
    addressLine2: "s2",
    pinCode: 0,
  });

  const handleAddNewState = () => {
    let dict = {
      code: modalData.stateCode,
      title: modalData.stateTitle,
    };
    addStateRegion(dict).then((res) => {
      if (res.err === 0) {
        toast.error( res.message);
      } else {
        toast.error( res.message, {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: true,
        });
      }
      getStateList();
    });
    setModalSwitches({
      ...modalSwitches,
      stateModal: false,
    });
  };

  const handleAddNewCountry = () => {
    let dict = {
      code: modalData.countryCode,
      title: modalData.countryTitle,
    };
    addCountry(dict).then((res) => {
      if (res.err === 0) {
        toast.error( res.message, {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: true,
        });
      } else {
        toast.error( res.message);
      }
      getCountryList();
    });
    setModalSwitches({
      ...modalSwitches,
      countryModal: false,
    });
  };

  const getCountryList = () => {
    getCountryKeyValuePair().then((res) => {
      if (res.errorCode == 0) {
        const options = res.responsePacket.map((d) => ({
          value: d.key,
          label: d.value,
        }));
        options.map((a) => {
          if (a.label == "[IND] - India") {
            child1.country=a
            child2.country=a
          }
        });

        setCountryKeyValue(options);

  
      }
    });
  };

  const getStateList = () => {
    getStateKeyValue().then((res) => {
      if (res.errorCode == 0) {
        const options = res.responsePacket.map((d) => ({
          value: d.key,
          label: d.value,
        }));
        setStateKeyValue(options);
      }
    });
  };

  const handleAddInfo = (e, key) => {
    if (e.value && e.label) {
      setAddInfo({
        ...addInfo,
        [key]: e,
      });
    } else if (e.target.value) {
      setAddInfo({
        ...addInfo,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleNewAddress = () => {
    let data = {
      // "addressId": 0,
      addressType: addInfo.addressType,
      attention: addInfo?.attention,
      city: addInfo.city,
      country: addInfo.country.label,
      fax: 0,
      isAdditionalAddress: true,
      // "recordId": "string",
      state: addInfo.state.label,
      addressLine1: addInfo.addressLine1,
      addressLine2: addInfo.addressLine2,
      pinCode: addInfo.pinCode,
    };
    addNewAddress(custDetail?.recordId, data).then((res) => {
      if (res.errorCode == 0) {
        handleClose();
        toast(res.message);
      } else {
        toast(res.message);
      }
    });
  };

const handleCopy1=()=>{
  var deepCopy1 = JSON.parse(JSON.stringify(child1));

  // if (!child2.recordId) {
  //   delete deepCopy1.recordId;
  // }

  props.handleCopy(deepCopy1);
}

  return (
    <>
      <Modal show={show} onHide={() => handleClose()}>
        <Modal.Body>
          <RadioGroup
            row
            value={addInfo.addressType}
            onChange={(e) =>
              setAddInfo({ ...addInfo, addressType: e.target.value })
            }
          >
            <FormControlLabel
              value="Billing"
              control={<Radio size="small" />}
              label="Billing"
            />
            <FormControlLabel
              value="Shipping"
              control={<Radio size="small" />}
              label="Shipping"
            />
          </RadioGroup>
          <table className="requiredTable" style={{ marginLeft: "10px" }}>
            <tr>
              <td style={{ width: "150px" }}>Country</td>
              <td style={{ width: "250px" }}>
                <Select
                  name="country"
                  options={countryKeyValue}
                  value={addInfo.country}
                  onChange={(e) => {
                    handleAddInfo(e, "country");
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>Address</td>
              <td>
                <textarea
                  placeholder="Street 1"
                  name="addressLine1"
                  className="form-control ember-text-area ember-view"
                  value={addInfo.addressLine1}
                  onChange={(e) => {
                    handleAddInfo(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <textarea
                  placeholder="Street 2"
                  name="addressLine2"
                  className="form-control ember-text-area ember-view"
                  value={addInfo.addressLine2}
                  onChange={(e) => {
                    handleAddInfo(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>City</td>
              <td>
                <input autoComplete="off"
                  name="city"
                  className="form-control ember-text-field ember-view"
                  value={addInfo.city}
                  onChange={(e) => {
                    handleAddInfo(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>State</td>
              <td>
                <Select
                  options={stateKeyValue}
                  value={addInfo.state}
                  onChange={(e) => {
                    handleAddInfo(e, "state");
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>ZipCode</td>
              <td>
                <input autoComplete="off"
                  className="form-control ember-text-field ember-view"
                  type="number"
                  name="pinCode"
                  value={addInfo.pinCode}
                  onChange={(e) => {
                    handleAddInfo(e);
                  }}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <button
            id="ember870"
            class="btn btn-info ember-view btn-sm"
            type="submit"
            onClick={handleNewAddress}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <div style={{ paddingBottom: "50px", paddingTop: "20px" }}>
        <div className="row">
          <table className="requiredTable" style={{ marginLeft: "10px" }}>
            <tr>
              <td></td>
              <td>Billing</td>
              <td>
                Shipping &nbsp;{" "}
                <Tooltip title="Copy Billing Address">
                  <ContentCopyIcon
                    style={{ cursor: "pointer" }}
                    onClick={handleCopy1}
                  />
                </Tooltip>
              </td>
            </tr>

            <tr>
              <td style={{ width: "150px" }}>Country</td>
              <td style={{ width: "250px" }}>
                <Select
                  name="country"
                  options={countryKeyValue}
                  value={child1.country}
                  onChange={(e) => {
                    props.handleChild1(e, "country");
                  }}
                />
              </td>
              <td style={{ width: "250px" }}>
                <Select
                  name="country"
                  options={countryKeyValue}
                  value={child2.country}
                  onChange={(e) => {
                    props.handleChild2(e, "country");
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>Address</td>
              <td>
                <textarea
                  placeholder="Street 1"
                  name="addressLine1"
                  className="form-control ember-text-area ember-view"
                  value={child1.addressLine1}
                  onChange={(e) => {
                    props.handleChild1(e);
                  }}
                />
              </td>
              <td>
                <textarea
                  placeholder="Street 1"
                  name="addressLine1"
                  className="form-control ember-text-area ember-view"
                  value={child2.addressLine1}
                  onChange={(e) => {
                    props.handleChild2(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <textarea
                  placeholder="Street 2"
                  name="addressLine2"
                  className="form-control ember-text-area ember-view"
                  value={child1.addressLine2}
                  onChange={(e) => {
                    props.handleChild1(e);
                  }}
                />
              </td>
              <td>
                <textarea
                  placeholder="Street 2"
                  name="addressLine2"
                  className="form-control ember-text-area ember-view"
                  value={child2.addressLine2}
                  onChange={(e) => {
                    props.handleChild2(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>City</td>
              <td>
                <input autoComplete="off"
                  name="city"
                  className="form-control ember-text-field ember-view"
                  value={child1.city}
                  onChange={(e) => {
                    props.handleChild1(e);
                  }}
                />
              </td>
              <td>
                <input autoComplete="off"
                  name="city"
                  className="form-control ember-text-field ember-view"
                  value={child2.city}
                  onChange={(e) => {
                    props.handleChild2(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>State</td>
              <td>
                <Select
                  options={stateKeyValue}
                  value={child1.state}
                  onChange={(e) => {
                    props.handleChild1(e, "state");
                  }}
                />
              </td>
              <td>
                <Select
                  options={stateKeyValue}
                  value={child2.state}
                  onChange={(e) => {
                    props.handleChild2(e, "state");
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>ZipCode</td>
              <td>
                <input autoComplete="off"
                  className="form-control ember-text-field ember-view"
                  type="number"
                  name="pinCode"
                  value={child1.pinCode}
                  onChange={(e) => {
                    props.handleChild1(e);
                  }}
                />
              </td>
              <td>
                <input autoComplete="off"
                  className="form-control ember-text-field ember-view"
                  type="number"
                  name="pinCode"
                  value={child2.pinCode}
                  onChange={(e) => {
                    props.handleChild2(e);
                  }}
                />
              </td>
            </tr>
          </table>
        </div>

        <div>
          {/* <button
            id="ember1426"
            className="btn btn-default addbtn mt-3"
            onClick={() => setShow(true)}
          >
            <AddIcon style={{ color: "blue" }} /> New Add
          </button> */}
        </div>
      </div>
      <Modal
        show={modalSwitches.countryModal}
        onHide={() =>
          setModalSwitches({
            ...modalSwitches,
            countryModal: false,
          })
        }
        size="sm"
        style={{ marginTop: "-30px" }}
      >
        <Modal.Header>
          <Modal.Title>
            <h4 className="modal-title">Add New country</h4>
            <button
              className="close no-outline"
              type="button"
              data-ember-action=""
              data-ember-action-2136="2136"
              onClick={() =>
                setModalSwitches({
                  ...modalSwitches,
                  countryModal: false,
                })
              }
              style={{ marginLeft: "640px", marginTop: "-30px" }}
            >
              ×
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body sales-person">
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="required">country Name*</label>
                <input autoComplete="off"
                  id="ember868"
                  class="ember-text-field ember-view form-control"
                  type="text"
                  value={modalData.countryTitle}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      countryTitle: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="required">country Code*</label>
                <textarea
                  id="ember868"
                  class="ember-text-field ember-view form-control"
                  type="text"
                  value={modalData.countryCode}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      countryCode: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 btn-toolbar">
                <button
                  id="ember870"
                  class="btn btn-info ember-view btn-sm"
                  type="submit"
                  onClick={handleAddNewCountry}
                >
                  Save
                </button>
                <button
                  class="btn btn-light btn-sm"
                  type="button"
                  data-ember-action=""
                  data-ember-action-871="871"
                  style={{ marginLeft: "10px" }}
                  onClick={() =>
                    setModalSwitches({
                      ...modalSwitches,
                      countryModal: false,
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={modalSwitches.stateModal}
        onHide={() =>
          setModalSwitches({
            ...modalSwitches,
            stateModal: false,
          })
        }
        size="sm"
        style={{ marginTop: "-30px" }}
      >
        <Modal.Header>
          <Modal.Title>
            <h4 className="modal-title">Add New country</h4>
            <button
              className="close no-outline"
              type="button"
              data-ember-action=""
              data-ember-action-2136="2136"
              onClick={() =>
                setModalSwitches({
                  ...modalSwitches,
                  countryModal: false,
                })
              }
              style={{ marginLeft: "640px", marginTop: "-30px" }}
            >
              ×
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body sales-person">
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="required">state Name</label>
                <input autoComplete="off"
                  id="ember868"
                  class="ember-text-field ember-view form-control"
                  type="text"
                  value={modalData.stateTitle}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      stateTitle: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="required">state Code</label>
                <textarea
                  id="ember868"
                  class="ember-text-field ember-view form-control"
                  type="text"
                  value={modalData.stateCode}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      stateCode: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 btn-toolbar">
                <button
                  id="ember870"
                  class="btn btn-info ember-view btn-sm"
                  type="submit"
                  onClick={handleAddNewState}
                >
                  Save
                </button>
                <button
                  class="btn btn-light btn-sm"
                  type="button"
                  data-ember-action=""
                  data-ember-action-871="871"
                  style={{ marginLeft: "10px" }}
                  onClick={() =>
                    setModalSwitches({
                      ...modalSwitches,
                      stateModal: false,
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Toaster />
    </>
  );
};
export default Address;
